import { UUID } from 'angular2-uuid';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface PdfOutputParams {
  handler: AnyHandler;
  params: any;
}


@Injectable({
  providedIn: 'root'
})
export class PDFOutputPreviewDialogService {
  id: string = UUID.UUID();
  public request$ = new Subject<PdfOutputParams>();
  constructor() {
    console.log(this.id);
  }


  Show(handler: AnyHandler, params: any) {
    this.request$.next({
      handler: (handler),
      params: (params)
    });

  }
}
